module.exports = __webpack_public_path__ + "img/icon-tick.906500e3.png";